import { makeStyles } from "@mui/styles";

// Shared layout styles for the PLSCADD KMZ Ingress tabs.
export const useStyles = makeStyles((theme) => ({
    formContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    inputRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: theme.spacing(2),
        margin: "10px 0",
        width: "100%",
        maxWidth: "700px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    buttonRow: {
        display: "flex",
        justifyContent: "center",
        margin: "20px 0",
    },
    fileInfo: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "20px 0",
    },
}));
